'use client';

import { useEffect } from 'react';
import type { ReactElement } from 'react';
import posthogJs from 'posthog-js';
import { captureBrowserException, getNextPublicPostHogEnv } from '@monorepo/posthog/browser';

const postHogEnv = getNextPublicPostHogEnv();
const postHogOptions = { serviceName: 'armstrong' };

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}): ReactElement {
  useEffect(() => {
    captureBrowserException(
      posthogJs,
      error,
      {
        source: 'app-error-boundary',
        digest: error.digest,
      },
      postHogEnv,
      postHogOptions
    );
  }, [error]);

  return (
    <main className="bg-background text-foreground flex min-h-screen items-center justify-center px-6">
      <div className="w-full max-w-sm space-y-4 text-center">
        <h1 className="text-2xl font-semibold">Something went wrong</h1>
        <p className="text-muted-foreground text-sm">The page failed to load.</p>
        <button
          className="bg-primary text-primary-foreground rounded-md px-4 py-2 text-sm font-medium"
          onClick={reset}
          type="button"
        >
          Try again
        </button>
      </div>
    </main>
  );
}
